<div *ngIf="!vinculo; else vinculoNew;" class="execucao-orcamentaria-loa">
  <div class="header_search header_search_mobile">
    <div class="title-page">
    </div>
    <div class="content_search">
      <div class="new-demand d-flex" *ngIf="permission?.new_assoc">
        <button class="btn-filters-close font-icon"  *ngIf="!deleting" type="button" (click)="deleting = true" title="Habilitar deleção dos itens">
          delete
        </button>
        <ng-container  *ngIf="deleting">
          <button class="btn btn-delete" type="button" (click)="confirmExcluir()" title="Excluir itens selecionados">
            Excluir
          </button>
          <button class="btn btn-white" type="button" (click)="deleting = false" title="Desabilitar deleção dos itens">
            Cancelar
          </button>
        </ng-container>
        <button type="button" class="btn btn-primary ms-2" (click)="novo()">Novo Vínculo</button>
      </div>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()">
    <div class="system-table table-container table-form">
      <div class="system-table-conteiner system-table-form-conteiner">
        <table>
          <thead>
            <tr>
              <th class="text-center column-delete" *ngIf="deleting" title="Selecione os itens que serão excluidos">
                <input type="checkbox" (change)="selectAll($event)">
              </th>
              <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'projeto_loa', title:'Projeto LOA' } }">
              </ng-container>
              <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'subprojeto', title:'Subprojeto LOA' } }">
              </ng-container>
              <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'recurso', title:'Recurso' } }">
              </ng-container>
              <ng-container *ngTemplateOutlet="columnOrder; context: { $implicit:{ id: 'grupo_natureza_despesa', title:'Natureza da Despesa' } }">
              </ng-container>
              <th class="text-center">Dotação c/ Alteração </th>
              <th class="text-center">Distribuição</th>
              <th class="text-center btn-icon-td action-column" *ngIf="!deleting">Ação</th>
            </tr>
          </thead>
          <tbody formArrayName="atribuicao">
            <ng-container *ngIf="filteredData?.length">
              <tr *ngFor="let item of filteredData; let i = index" [formGroupName]="i">
                <td class="text-center delete-cell" *ngIf="deleting" title="Selecionar">
                  <input type="checkbox" formControlName="checked" >
                </td>
                <td class="title">
                  <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                      id: item?.execucao_orcamentaria_carteira?.projeto_loa,
                      label: item?.execucao_orcamentaria_carteira?.fpe_projeto_loa?.nome_extenso,
                      showProjName: item?.showProjName
                    } }">
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                      id: formatSubprojeto(item),
                      label: item?.execucao_orcamentaria_carteira?.fpeAcao?.nome_extenso,
                      showProjName: item?.showProjName
                    } }">
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                      id: item?.execucao_orcamentaria_carteira?.recurso,
                      label: item?.execucao_orcamentaria_carteira?.execucao_orcamentaria_recursos?.nome_reduzido,
                      showProjName: item?.showProjName
                    } }">
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                      id: item?.execucao_orcamentaria_carteira?.grupo_natureza_despesa,
                      label: item?.execucao_orcamentaria_carteira?.execucao_orcamentaria_natureza_despesa?.nome_reduzido,
                      showProjName: item?.showProjName
                    } }">
                  </ng-container>
                </td>
                <td class="text-center">{{ item?.dotacao| number:'1.2-2' }}</td>
                <td>
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <ng-select id="atribuicao_id" class="ng-select-alternative" [items]="filter" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="atribuicao_id">
                        <ng-template ng-option-tmp let-item="item">
                          <div [title]="item.title">{{ item.label }}</div>
                        </ng-template>
                      </ng-select>
                      <app-field-message [field]="fieldMessageRequireds('atribuicao_id', i)" [erros]="fieldErrosFormArray('atribuicao_id', i)"></app-field-message>
                    </div>
                  </div>
                </td>
                <td *ngIf="!deleting" class="action-column">
                  <div class="btn-icon">
                    <span class="icon-table icon-red" (click)="confirmExcluirSingle(item?.id)" *ngIf="permission?.edit_assoc">
                      <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                    </span>
                  </div>
                </td>
              </tr>
            </ng-container>
            <tr *ngIf="!data?.execucao_orcamentaria_distribuicao?.length" class="border-b-radius">
              <td colspan="7" class="text-center">Nenhum Vínculo cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-default btn" type="button" (click)="distribution = !distribution">Visualizar distribuição</button>
        <button class="btn btn-primary btn m-l" type="submit" *ngIf="permission?.save_assoc && !deleting">Salvar</button>
      </div>
    </div>
  </form>

  <div *ngIf="distribution">
    <div class="info-page">
      <h3>Distribuição</h3>
    </div>
    <mat-accordion class="" multi [togglePosition]="'before'">
      <ng-container *ngFor="let distributions of distributionList; let i = index">
        <mat-expansion-panel class="mb-2">
          <mat-expansion-panel-header >
            <mat-panel-title class="d-flex justify-content-between" [title]="">
              <div class="max-title">
                <h3>{{ distributions?.name }}</h3>
              </div>
              <div class="d-flex justify-content-end">
                <button class="btn btn-font-icon ms-1" type="button" (click)="accordion.openAll()"
                  alt="Selecionar todos" title="Abrir todos">
                  expand
                </button>
                <button class="btn btn-font-icon ms-1" type="button"  (click)="accordion.closeAll()"
                  alt="Selecionar todos" title="Fechar todos">
                  compress
                </button>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-accordion #accordion="matAccordion" class="" multi [togglePosition]="'before'">
            <ng-container *ngFor="let distribution of distributions?.list; let i = index">
              <mat-expansion-panel class="mb-2">
                <mat-expansion-panel-header>
                  <div>
                    <h3>{{distribution?.pf_indicator?.code ?? distribution?.pf_prt_issue?.code}} - {{ distribution?.label }}</h3>
                  </div>
                </mat-expansion-panel-header>
                <div class="system-table table-container table-form">
                  <div class="system-table-conteiner system-table-form-conteiner">
                    <table>
                      <thead>
                        <tr>
                          <th>Projeto LOA</th>
                          <th>Subprojeto LOA </th>
                          <th >Recurso</th>
                          <th >Natureza da Despesa </th>
                          <th class="text-center">Dotação c/ Alteração </th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="distribution?.execucao_orcamentaria_distribuicao.length">
                          <tr *ngFor="let item of distribution?.execucao_orcamentaria_distribuicao; let i = index">
                            <td class="title" >
                              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                                  id: item?.execucao_orcamentaria_carteira?.projeto_loa,
                                  label: item?.execucao_orcamentaria_carteira?.fpe_projeto_loa?.nome_extenso,
                                  showProjName: item?.showProjName
                                } }">
                              </ng-container>
                            </td>
                            <td>
                              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                                  id: formatSubprojeto(item),
                                  label: item?.execucao_orcamentaria_carteira?.fpeAcao?.nome_extenso,
                                  showProjName: item?.showProjName
                                } }">
                              </ng-container>
                            </td>
                            <td>
                              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                                  id: item?.execucao_orcamentaria_carteira?.recurso,
                                  label: item?.execucao_orcamentaria_carteira?.execucao_orcamentaria_recursos?.nome_reduzido,
                                  showProjName: item?.showProjName
                                } }">
                              </ng-container>
                            </td>
                            <td>
                              <ng-container *ngTemplateOutlet="tdLabel; context: { $implicit:{
                                  id: item?.execucao_orcamentaria_carteira?.grupo_natureza_despesa,
                                  label: item?.execucao_orcamentaria_carteira?.execucao_orcamentaria_natureza_despesa?.nome_reduzido,
                                  showProjName: item?.showProjName
                                } }">
                              </ng-container>
                            </td>
                            <td class="text-center" >{{item?.dotacao| number:'1.2-2' }}</td>
                          </tr>
                        </ng-container>
                        <tr *ngIf="!distribution?.execucao_orcamentaria_distribuicao.length" class="border-b-radius">
                          <td colspan="7" class="text-center">Nenhuma Distribuição cadastrada.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
            </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>
</div>

<ng-template #vinculoNew>
  <app-detalhe-projeto-execucao-orcamentaria-loa-new [idExecucao]="idExecucao"></app-detalhe-projeto-execucao-orcamentaria-loa-new>
</ng-template>

<br>
<app-historico-atualizacoes-list [listAudit]="listAudit" [loadList]="false" [key]="'budget_assoc_fpe_id'"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>

<ng-template #tdLabel let-data>
  <div class="resp-content" title="{{data.label}}">
    <div>{{ data.id }}
      <span class="icone-info" *ngIf="data.label" (click)="data.showProjName = !data?.showProjName">
        <i class="pl-1 fa fas fa-chevron-circle-down"></i>
      </span>
    </div>
    <div class="resp-info" *ngIf="data?.showProjName">
      <div class="manager-info">
        <div>{{ data.label }}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #columnOrder let-data>
  <th>
    <div class="columnOrder">
      <b>{{data.title}}</b>
      <button class="btn font-icon orderIcon"  type="button" (click)="orderData(data.id)"> swap_vert </button>
    </div>
  </th>
</ng-template>